function answerBlockUi(type, results = [], source, fromCategory = false, researchKeywords = null) {  
    const logFactory = GlobalSite.checkDependency('GlobalSite.logFactory');
    const inbentaApi = GlobalSite.checkDependency('GlobalSite.inbentaApi');
    const redirection = GlobalSite.checkDependency('GlobalSite.getFaqRedirection');
    const Log = logFactory('answerBlockHandler.js');
    const $root = $('.inbenta-faq-list');
    const $title = $('.inbenta-faq__results-infos-nbr');
    const $listItems = $('.inbenta-faq-list-items');
    const $showMoreBtn = $('.inbenta-more-results-btn');
    const showMoreMessageInit = $showMoreBtn.find('button').text();
    const nbItem = results.length;

    const config = {
      search: { text: '<span></span> résultats pour la recherche</p>' },
      popular: { text: '<b class="font-ubuntu">Les <span class="text-green-medium">5 questions</span> les plus consultées</b>' },
    };

    let $listItem;

    function template() {
      return results
        .map((suggestion, index) => {
          return ` 
            <li class="inbenta-faq-list-item ${index > 4 ? 'inbenta-faq-list-item--hidden' : ''}">
              <a
                href="${redirection?.answer}${suggestion.slug}${researchKeywords ? `?q=${researchKeywords}` : ''}"
                data-source="${source}-track"
                data-tracking-type="click"
                data-tracking-value="${suggestion?.tracking?.clickCode || ''}"
                class="inbenta-faq-list-link"
                aria-label="${suggestion.title}"
              >
                ${suggestion.title}
              </a>
            </li>`;
        })
        .join('');
    }

    (function render() {
      if ((type === "search") && (nbItem === 0)) {
        $listItems.addClass("popular")
      } else if ((type === "search") && (nbItem > 0)) {
        $listItems.removeClass("popular")
      }

      $showMoreBtn.css("display", "");;
      $title.text('').append(config[type]?.text || type);
      $listItems.html(template());
      $listItem = $('.inbenta-faq-list-item');
      if (nbItem === 0) {
        $showMoreBtn.hide();
      } else if (nbItem <= 5) {
        $showMoreBtn.hide();
      }
      $root.removeClass('hide');
    })();

    $showMoreBtn.on('click focus', () => {
      $listItem.slice(5, nbItem).toggleClass('inbenta-faq-list-item--hidden');

      if ($listItem.is('.inbenta-faq-list-item--hidden')) {
        $showMoreBtn.find('button').text(showMoreMessageInit);
      } else {
        $showMoreBtn.find('button').text('Afficher moins de résultats');
      }
    });

    $listItem.on('click', (e) => {
      if (inbentaApi.isTracking()) {
        e.preventDefault();
        const $this = $(e.target);
        const source = $this.data('source');
        const trackingType = $this.data('trackingType');
        const trackingValue = $this.data('trackingValue');
        inbentaApi.sendTrackingEvents({ type: trackingType, data: { code: trackingValue } }, source);
        window.location.replace($this.attr('href'));
        Log.log({ trackingType, trackingValue, source });
      }
    });
  }

(function answerBlockHandler() {
  window.GlobalSite = window.GlobalSite || {};

  const exportToGlobalSite = GlobalSite.checkDependency('GlobalSite.exportToGlobalSite');

  exportToGlobalSite({
    answerBlockUi,
  });
})();
